import { Tooltip as BaseTooltip } from "@base-ui/react/tooltip";
import { cn } from "./cn";

const popupClasses =
    "rounded-md bg-fg px-2 py-1 text-xs font-medium text-white shadow-md " +
    "transition-opacity duration-100 " +
    "data-[starting-style]:opacity-0 data-[ending-style]:opacity-0";

/**
 * Tooltip (Base UI). Mount <Tooltip.Provider> once near the app root, then:
 *
 *   <Tooltip.Root>
 *     <Tooltip.Trigger render={<Button>Hover me</Button>} />
 *     <Tooltip.Content>Helpful hint</Tooltip.Content>
 *   </Tooltip.Root>
 */
export const Tooltip = {
    Provider: BaseTooltip.Provider,
    Root: BaseTooltip.Root,
    Trigger: BaseTooltip.Trigger,
    /** Portal + positioner + popup in one convenient wrapper. */
    Content: function Content({
        className,
        children,
        sideOffset = 6,
        ...props
    }: React.ComponentPropsWithoutRef<typeof BaseTooltip.Positioner>) {
        return (
            <BaseTooltip.Portal>
                {/* z-index on the Positioner (the positioned element), not the Popup. */}
                <BaseTooltip.Positioner className="z-[1200]" sideOffset={sideOffset} {...props}>
                    <BaseTooltip.Popup className={cn(popupClasses, className as string)}>
                        {children}
                    </BaseTooltip.Popup>
                </BaseTooltip.Positioner>
            </BaseTooltip.Portal>
        );
    },
};
